import { render, staticRenderFns } from "./MediaViewerComponent.vue?vue&type=template&id=5f5d7182&"
import script from "./MediaViewerComponent.vue?vue&type=script&lang=js&"
export * from "./MediaViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./MediaViewerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports